import {
    createRecurrency,
    deleteRecurrency,
    updateRecurrency,
} from "@/api/recurringPayment";
import {
    create,
    deleteItem,
    getAll,
    getOblTypesList,
    operationSum,
    updatePartial,
} from "@/api/taxDocument";
import moment from "moment";
export default {
    state: {
        modalData: {
            counterpart: {},
            document_number: "",
            amount: 0,
            obligation_type: {
                id: 1,
                name: "",
                associated_document_type: "",
            },
        },
        tableData: {
            params: {
                page: 1,
            },
            loading: false,
        },
        taxDocumentsList: [],
        obligationTypesList: [],
        numberRegisters: 0,
        taxDocument: {
            document_number: "",
            emitted_at: new Date(),
            payment_period: 30,
            document_type: "P",
            amount: 0,
            counterpart: {
                rut: "",
                name: "",
            },
            obligation_type: {
                id: 1,
                name: "",
                associated_document_type: "",
                enable_recurrent_payment: false,
            },
        },
        recurrency: {
            id: 0,
            indefinite_term: false,
            payment_day: 0,
            valid_from: new Date(),
            valid_until: new Date(),
            amount: 0,
        },
        totalPay: 0,
        totalCollect: 0,
    },
    mutations: {
        SET_MODAL_DATA: (state, payload) => {
            state.modalData = payload;
        },
        SET_TOTAL_PAY: (state, payload) => {
            state.totalPay = payload;
        },
        SET_TOTAL_COLLECT: (state, payload) => {
            state.totalCollect = payload;
        },
        SET_TAX_DOCUMENTS_LIST: (state, payload) => {
            state.taxDocumentsList = payload;
        },
        SET_NUMBER_REGISTERS: (state, payload) => {
            state.numberRegisters = payload;
        },
        SET_TAX_DOCUMENT: (state, payload) => {
            state.taxDocumentsList.unshift(payload);
        },
        SET_OBLIGATION_TYPE_LIST: (state, payload) => {
            state.obligationTypesList = payload;
        },
        UPDATE_TAX_DOCUMENT: (state, payload) => {
            state.taxDocumentsList = state.taxDocumentsList.filter((item) => {
                if (
                    item.id === payload.id &&
                    item.document_type === payload.field.document_type
                ) {
                    if (payload.field.possible_payment_date) {
                        item.possible_payment_date =
                            payload.field.possible_payment_date;
                    }
                    if (payload.field.operation_status) {
                        item.operation_status = payload.field.operation_status;
                    }
                    if (payload.field.amount) {
                        item.amount = payload.field.amount
                            .replace("$ ", "")
                            .replace(/\./g, "");
                    }
                    if (payload.field.document_number) {
                        item.document_number = payload.field.document_number;
                    }
                }
                return item;
            });
        },
        DEL_TAX_DOCUMENT: (state, id) => {
            state.taxDocumentsList = state.taxDocumentsList.filter(
                (item) => item.id !== id
            );
        },
        SET_TABLE_PARAMS: (state, payload) => {
            state.tableData.params = payload;
        },
        SET_TABLE_LOADING: (state, payload) => {
            state.tableData.loading = payload;
        },
    },
    actions: {
        getObligationTypesList({ commit }) {
            return new Promise((resolve, reject) => {
                getOblTypesList()
                    .then((response) => {
                        commit("SET_OBLIGATION_TYPE_LIST", response.data);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        commit("SET_OBLIGATION_TYPE_LIST", null);
                        reject(error);
                    });
            });
        },
        getAllTaxDocuments({ state, commit }) {
            commit("SET_TABLE_LOADING", true);
            return new Promise((resolve, reject) => {
                getAll({ params: state.tableData.params })
                    .then((response) => {
                        let data = [];
                        response.data.results.forEach((element) => {
                            let {
                                emitted_at,
                                due_date,
                                possible_payment_date,
                                ...taxDocument
                            } = element;
                            element = Object.assign({}, taxDocument, {
                                emitted_at: moment(emitted_at).format(
                                    "YYYY-MM-DD"
                                ),
                                due_date: moment(due_date).format("YYYY-MM-DD"),
                                possible_payment_date: moment(
                                    possible_payment_date
                                ).format("YYYY-MM-DD"),
                            });
                            data.push(element);
                        });
                        commit("SET_TAX_DOCUMENTS_LIST", data);
                        commit("SET_NUMBER_REGISTERS", response.data.count);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .finally(() => {
                        commit("SET_TABLE_LOADING", false);
                    });
            });
        },
        getTotalPay({ commit }) {
            let document_type = "P";
            operationSum(document_type).then((response) => {
                let data = response?.data?.total || 0;
                commit("SET_TOTAL_PAY", data);
            });
        },
        getTotalCollect({ commit }) {
            let document_type = "C";
            operationSum(document_type).then((response) => {
                let data = response?.data?.total || 0;
                commit("SET_TOTAL_COLLECT", data);
            });
        },
        createTaxDocument({ state }, edit) {
            let { emitted_at, ...taxDocument } = edit;
            let data = Object.assign({}, taxDocument, {
                emitted_at: moment(emitted_at).format("YYYY-MM-DD"),
            });
            return new Promise((resolve, reject) => {
                data.counterpart.rut = data.counterpart.rut.replace(/\./g, "");
                data.amount = data.amount.replace("$ ", "").replace(/\./g, "");
                data.obligation_type = state.obligationTypesList.find(
                    (type) => data.obligation_type.id === type.id
                );
                create(data)
                    .then((response) => {
                        let data = response.data;
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        updateTaxDocument({ commit }, data) {
            return new Promise((resolve, reject) => {
                updatePartial(data)
                    .then(() => {
                        commit("UPDATE_TAX_DOCUMENT", data);
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteTaxDocument({ commit }, id) {
            return new Promise((resolve, reject) => {
                deleteItem(id)
                    .then(() => {
                        commit("DEL_TAX_DOCUMENT", id);
                        resolve(id);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        // eslint-disable-next-line no-unused-vars
        createRecurrent({ state }, edit) {
            let data = Object.assign({}, edit);
            return new Promise((resolve, reject) => {
                data.valid_from = moment(data.recurrency.valid_from).format(
                    "YYYY-MM-DD"
                );
                data.valid_until = moment(data.recurrency.valid_until).format(
                    "YYYY-MM-DD"
                );
                if (typeof edit.amount === "string") {
                    data.amount = edit.amount
                        .replace("$ ", "")
                        .replace(/\./g, "");
                }
                data.counterpart.rut = data.counterpart.rut.replace(/\./g, "");
                data.obligation_type = edit.obligation_type.id;
                data.indefinite_term = edit.recurrency.indefinite_term;
                data.payment_day = edit.recurrency.payment_day;
                createRecurrency(data)
                    .then((response) => {
                        let data = response.data;
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        // eslint-disable-next-line no-unused-vars
        updateRecurrent({ state }, data) {
            return new Promise((resolve, reject) => {
                updateRecurrency(data)
                    .then(() => {
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        // eslint-disable-next-line no-unused-vars
        terminateRecurrent({ state }, data) {
            return new Promise((resolve, reject) => {
                updateRecurrency(data)
                    .then(() => {
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        // eslint-disable-next-line no-unused-vars
        deleteRecurrency({ state }, data) {
            return new Promise((resolve, reject) => {
                deleteRecurrency(data)
                    .then(() => {
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
    namespaced: true,
};
